import { db, SegmentDrawConfig } from 'technical/db';

export const segmentDrawConfigSyncService = {
  async download(configs: SegmentDrawConfig[]): Promise<void> {
    await db.segmentDrawConfigs.bulkPut(configs);
  },

  async reset(): Promise<void> {
    await db.segmentDrawConfigs.clear();
  },
};
